import request from '@/utils/request'

// 查询公告列表
export function listNotice (query) {
  return request({
    url: '/system/notice/list',
    method: 'get',
    params: query
  })
}

// 查询公告列表1
export function listNotice1 (query) {
  return request({
    url: '/system/notice/list1',
    method: 'get',
    params: query
  })
}
export function listNotice2 (query) {
  return request({
    url: '/system/notice/list2',
    method: 'get',
    params: query
  })
}
// 查询公告详细
export function getNotice (noticeId) {
  return request({
    url: '/system/notice/' + noticeId,
    method: 'get'
  })
}

// 新增公告
export function addNotice (data) {
  return request({
    url: '/system/notice',
    method: 'post',
    data: data
  })
}

// 修改公告
export function updateNotice (data) {
  return request({
    url: '/system/notice',
    method: 'put',
    data: data
  })
}

// 根据id批量关闭状态
export function batchCloseStatus (type, relationType, noticeIds) {
  return request({
    url: '/system/notice/' + type + '/' + relationType + '/' + noticeIds,
    method: 'put'
  })
}

// 删除公告
export function delNotice (noticeId) {
  return request({
    url: '/system/notice/' + noticeId,
    method: 'delete'
  })
}
